import Layout from "components/Layout";
import { ICorporateDashboardLayout } from "./CorporateDashboardLayoutInterfaces";
import DowntimeAppDrawerItems from "pages/Corporate/components/DowntimeAppDrawerItems";
import { useStyles } from "./CorporateDashboardLayout.styles";
import { useTranslation } from "react-i18next";
import DowntimeAppDrawerFooterItems from "pages/Corporate/components/DowntimeAppDrawerFooterItems";
import Module1Icon from "components/Module1Icon";

const CorporateDashboardLayout = ({ children }: ICorporateDashboardLayout) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Layout
            appDrawerItems={<DowntimeAppDrawerItems />}
            appDrawerFooterItems={
                process.env.REACT_APP_SHOW_DOWNTIME_HELP?.toLocaleLowerCase() === "true" ? (
                    <DowntimeAppDrawerFooterItems />
                ) : null
            }
            toolbarLogo={
                <>
                    <Module1Icon />
                    <span className={classes.mainTitle}>{t("corporate_dashboard.title")}</span>
                </>
            }
        >
            {children}
        </Layout>
    );
};

export default CorporateDashboardLayout;
